import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SuccessIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';

export const VendorDetailsRequestFormSuccess = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col w-full h-full items-center  shadow-md rounded-md max-w-[588px]  overflow-hidden'>
      <div className='flex flex-col items-center h-full justify-center pb-[30px]'>
        <SuccessIcon />
        <p className='font-metricRSemibold text-[18px] text-bw08 text-center mt-[26px]'>
          {t('ASK_VENDOR.PAYMENT_SUCCESS.TITLE')}
        </p>
        <p className='font-metricR text-[16px] text-bw08 text-center mt-[14px] max-w-[315px]'>
          {t('ASK_VENDOR.PAYMENT_SUCCESS.MESSAGE')}
        </p>
      </div>
    </div>
  );
};
